import React, { Component } from 'react';

import { Container, H1 } from 'components';

import './EmailConfirmationPage.css';

class EmailConfirmationPage extends Component {
    render() {
        return (
            <div className="email-confirmation-page page">
                <Container>
                    <H1>A confirmation email has been sent</H1>
                    <p>
                    Thank you for signing up. There is just one more step. Please check your email; and respond. After responding, you will have use of the quoting tool for 30 days.
                    </p>
                </Container>
            </div>
        );
    }
}

export default EmailConfirmationPage;



// WEBPACK FOOTER //
// ./src/modules/email-confirmation/EmailConfirmationPage.jsx